import BaseComponent from "../../../../../lib/components/BaseComponent";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import {TextField} from "@mui/material";
import {createRef} from "react";
import Button from "@mui/material/Button";
import TabBarHorizontal2 from "../../../../../lib/components/tabbar/TabBarHorizontal2";
import VerticalTabBar from "../../../../../appl/view/components/tabbar/VerticalTabBar";
import BaseTab from "../../../../../appl/view/components/tabbar/BaseTab";
import HorizontalTabBar from "../../../../../appl/view/components/tabbar/HorizontalTabBar";

class TabBarDynamicAdd2Test extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      tabs: [], value: 0, contents: [], pos: 0
    };
    this.horizontalTabBarRef = createRef();
    this.tabBarTestRef = createRef();
  }

  onCLick = (event) => {
    this.state.pos++;
    // this.horizontalTabBarRef.current.addTab('First added Tab ' + this.state.pos, <div className="text-white">{<TextField defaultValue={'def-vakue=' + this.state.pos}/>}</div>);
    this.tabBarTestRef.current.addTab(<BaseTab tabTitle={'First added Tab ' + this.state.pos}/>, <div className="text-white">{<TextField defaultValue={'def-vakue=' + this.state.pos}/>}</div>);
  };

  render() {
    return <VerticalLayout className="sandbox-container gap-4">
      {/*<TabBarHorizontal2 ref={this.horizontalTabBarRef}/>*/}
      {<HorizontalTabBar ref={this.tabBarTestRef}/>}
      <Button onClick={this.onCLick}>Add to Tabbar</Button>
    </VerticalLayout>;
  }
}

export default TabBarDynamicAdd2Test;
